var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fixed-button',{attrs:{"width":_vm.width,"height":_vm.height,"appear-at":_vm.appearAt,"is-visible":_vm.scrolling},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-chevron-up fa-fw",style:(_vm.iconStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }